import { useAxios } from "../../utils/hooks/useAxios";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { handleFormErrors } from "../../utils/helpers";
import { useNavigate } from "react-router";

// ******* Queries *******
export const useGetCurrentUserProfileQuery = (options = {}) => {
  const { axiosProtected } = useAxios();

  return useQuery({
    queryKey: ["profile"],
    queryFn: () => axiosProtected.get("profile"),
    onError: (err) => {
      toast.error(err?.message || "Failed to get current user");
    },
    ...options,
  });
};

// ******* Mutations *******
export const useUpdateProfileMutation = (setError) => {
  const { axiosProtected } = useAxios();
  const { t } = useTranslation();

  const updateProfileMutation = useMutation({
    mutationFn: (payload) => axiosProtected.put("profile", payload),
    mutationKey: "updateProfile",
    onSuccess: () => {
      toast.success(t("CHANGES_SAVED_SUCCESSFULLY"));
    },
    onError: (err) => {
      handleFormErrors(err, setError);
      toast.error(t("CHANGES_SAVED_FAILED"));
    },
  });
  return updateProfileMutation;
};
export const useChangeEmailMutation = (setError) => {
  const { axiosProtected } = useAxios();

  return useMutation({
    mutationFn: (payload) => axiosProtected.post("profile/sendOtp", payload),
    mutationKey: "update-email",
    onSuccess: (_, payload) => {
      localStorage.setItem("changeEmailTo", payload.email);
      localStorage.setItem(
        "changeEmailExpireAt",
        new Date(Date.now() + 10 * 60 * 1000).toISOString()
      );
    },
    onError: (err) => {
      handleFormErrors(err, setError);
    },
  });
};
export const useConfirmOtpMutation = (setError) => {
  const { axiosProtected } = useAxios();
  const navigate = useNavigate();
const { t } = useTranslation();

  return useMutation({
    mutationFn: (payload) => axiosProtected.post("profile/confirmOtp", payload),
    mutationKey: "confirm-otp",
    onSuccess: () => {
      toast.success(t("EMAIL_CHANGED_SUCCESSFULLY"));
      localStorage.removeItem("changeEmailTo");
      localStorage.removeItem("changeEmailExpireAt");
      navigate("/app/me");
    },
    onError: (err) => {
      handleFormErrors(err, setError);
    },
  });
};
